module.exports = __webpack_public_path__ + "static/img/10001 (3).32bb733.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10001 (3).webp
// module id = hfcJ
// module chunks = 14